import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/auth.service';
import { PopupAndNotifService } from '../../core/services/popup-and-notif.service';

@Component({
  selector: 'app-site-maintenance',
  standalone: true,
  imports: [RouterModule, MaterialModule, MatButtonModule],
  templateUrl: './site-maintenance.component.html',
  styleUrl: './site-maintenance.component.scss',
})
export class SiteMaintenanceComponent {
  constructor(
    private router: Router,
    private location: Location,
    private authService: AuthService,
    private popupAndNotifService: PopupAndNotifService
  ) {}

  goBackToHome(): void {
    if (environment.maintenanceMode) {
      this.popupAndNotifService.showNotification(
        'Maintenance is enforced by the application configuration.',
        '',
        'info'
      );
      return;
    }

    const urlTree = this.router.createUrlTree(['/pages-dashboard']);
    const path = this.router.serializeUrl(urlTree);
    window.location.href = this.location.prepareExternalUrl(path);
  }

  logout() {
    void this.authService.logout().subscribe(() => {
      void this.router.navigate(['/login']);
    });
  }
}
